import React from 'react';

function DateRangeFilter({ startDate, endDate, setStartDate, setEndDate, minDate, maxDate, className = "" }) {
  return (
    <div className={`flex flex-row gap-2 w-full sm:w-auto ${className}`}>
      <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Data início:
        <input
          type="date"
          className="ml-2 border rounded px-2 py-1 text-sm"
          value={startDate}
          min={minDate}
          max={endDate}
          onChange={e => setStartDate(e.target.value)}
        />
      </label>
      <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Data fim:
        <input
          type="date"
          className="ml-2 border rounded px-2 py-1 text-sm"
          value={endDate}
          min={startDate}
          max={maxDate}
          onChange={e => setEndDate(e.target.value)}
        />
      </label>
    </div>
  );
}

export default DateRangeFilter;
